import { PlatformDetectionService } from '@libs/util/shared';
import { NavigationBarService } from './navigation-bar.service';

/**
 * Creates a new instance of {@link NavigationBarService}. When running the application on a browser or iOS,
 * the service is mocked using a {@link Proxy}, so no operation will be executed.
 * This avoids console errors on browser.
 * @param platformDetectionService The service to determine the platform
 */
export function navigationBarServiceFactory(platformDetectionService: PlatformDetectionService): NavigationBarService {
  const instance = new NavigationBarService();

  if (platformDetectionService.isAndroid()) {
    return instance;
  }

  const handler = {
    get() {
      return () => Promise.resolve();
    },
  };

  return new Proxy(instance, handler);
}
